import { AnchorHTMLAttributes } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { LoaderWrapper } from 'components/loading';
import { BaseButtonProps } from 'types';
import { getButtonStyle } from 'commons';
import { Link } from 'react-router-dom';

interface Props
  extends AnchorHTMLAttributes<HTMLAnchorElement>,
    BaseButtonProps {
  to?: string;
}

export function Anchor({
  variant = 'link',
  full = false,
  children,
  isLoading = false,
  hidden = false,
  className = '',
  to,
  ...rest
}: Props) {
  if (to) {
    return (
      <Link
        to={to}
        className={getButtonStyle({ variant, className, full, hidden })}
        {...rest}
      >
        {!isLoading ? (
          children
        ) : (
          <LoaderWrapper>
            <AiOutlineLoading3Quarters size={20} />
          </LoaderWrapper>
        )}
      </Link>
    );
  }

  return (
    <a
      className={getButtonStyle({ variant, className, full, hidden })}
      {...rest}
    >
      {!isLoading ? (
        children
      ) : (
        <LoaderWrapper>
          <AiOutlineLoading3Quarters size={20} />
        </LoaderWrapper>
      )}
    </a>
  );
}
